// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"ec684d19","242":"4c4dc3c1","515":"f53a484d"}[chunkId] + ".chunk.css";
};